import React, { useEffect, useState } from "react";
import { Button, Offcanvas } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ContactsList from "./ContactsList";
import { proxyAPI } from "../proxyAPI";
import { faCaretLeft, faCaretRight } from "@fortawesome/free-solid-svg-icons";

export default function ContactSetMembers({
  uuid,
  contactButton,
  label = "members",
}) {
  const [members, setMembers] = useState([]);
  const [show, setShow] = useState(false);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(0);
  const perPage = 5;

  const getMembers = async () => {
    const data = await proxyAPI({
      prefix: "contacts/v1",
      url: `/contact-set-members/${uuid}?fields.cards=1&fields.channels=1&paginate.page=${page}&paginate.per_page=${perPage}`,
    });
    if (data.contacts) {
      setMembers(data.contacts);
      setTotal(data.pagination?.total);
    }
  };

  useEffect(() => {
    if (show) {
      getMembers();
    }
  }, [show, uuid, page]);

  return (
    <>
      <Button
        variant="link link-secondary"
        className="align-baseline p-0"
        onClick={() => setShow(true)}
      >
        {label}
      </Button>

      <Offcanvas placement="end" show={show} onHide={() => setShow(false)}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Group members</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <ContactsList contacts={members} contactButton={contactButton} />
          <div className="text-center">
            Total {total} contacts found. Showing {page * perPage + 1} -{" "}
            {page * perPage + members.length} <br />
            <button
              type="button"
              className="btn btn-link align-baseline"
              onClick={() => setPage((p) => p - 1)}
              disabled={page === 0}
            >
              <FontAwesomeIcon icon={faCaretLeft} />
            </button>
            <button
              type="button"
              className="btn btn-link align-baseline"
              onClick={() => setPage((p) => p + 1)}
              disabled={total <= (page + 1) * perPage}
            >
              <FontAwesomeIcon icon={faCaretRight} />
            </button>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}
